import { TypedDocumentNode } from 'providers/tanstack-query/types'
import { gql } from 'providers/tanstack-query/utils'
import { WorkspaceUserDTO } from '../types/workspaceUser'

export const WORKSPACE_USER_FRAGMENT: TypedDocumentNode<WorkspaceUserDTO> = gql`
  fragment WorkspaceUserFragment on User {
    currentWorkspaceRole
    email
    id
  }
`
